import { render, staticRenderFns } from "./SitiosInteres.vue?vue&type=template&id=54a474f0&scoped=true&"
import script from "./SitiosInteres.vue?vue&type=script&lang=js&"
export * from "./SitiosInteres.vue?vue&type=script&lang=js&"
import style0 from "./SitiosInteres.vue?vue&type=style&index=0&id=54a474f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a474f0",
  null
  
)

export default component.exports